import React, { Component } from 'react'
import { Alert } from 'antd'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import moment from 'moment'

class MaintenanceBanner extends Component {
  constructor(props) {
    super(props)
    this.state = {
      timeLeft: null,
      showBanner: false,
    }
    this.intervalId = null
  }

  componentDidMount() {
    this.updateCountdown()
    this.intervalId = setInterval(() => {
      this.updateCountdown()
    }, 1000)
  }

  componentWillUnmount() {
    if (this.intervalId) {
      clearInterval(this.intervalId)
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.maintenanceInfo !== this.props.maintenanceInfo) {
      this.updateCountdown()
    }
  }

  updateCountdown = () => {
    const { maintenanceInfo } = this.props

    if (!maintenanceInfo || !maintenanceInfo.startDate) {
      this.setState({ showBanner: false, timeLeft: null })
      return
    }

    const now = moment()
    const startDate = moment(maintenanceInfo.startDate)

    // Validate that startDate is a valid date
    if (!startDate.isValid()) {
      this.setState({ showBanner: false, timeLeft: null })
      return
    }

    const secondsUntilStart = startDate.diff(now, 'seconds')

    // If maintenance has started (time <= 0), hide banner and reload to trigger maintenance check
    if (secondsUntilStart <= 0) {
      this.setState({ showBanner: false, timeLeft: null })
      // Reload the page to trigger the app status check which will redirect to maintenance
      window.location.reload()
      return
    }

    const minutesUntilStart = startDate.diff(now, 'minutes')

    // Show banner only if less than 15 minutes until maintenance
    if (minutesUntilStart <= 15) {
      const duration = moment.duration(startDate.diff(now))
      const hours = Math.floor(duration.asHours())
      const minutes = duration.minutes()
      const seconds = duration.seconds()

      this.setState({
        showBanner: true,
        timeLeft: { hours, minutes, seconds },
      })
    } else {
      this.setState({ showBanner: false, timeLeft: null })
    }
  }

  formatTimeLeft = () => {
    const { timeLeft } = this.state
    const { t } = this.props

    if (!timeLeft) return ''

    const parts = []
    if (timeLeft.hours > 0) {
      parts.push(`${timeLeft.hours}${t('h')}`)
    }
    if (timeLeft.minutes > 0 || timeLeft.hours > 0) {
      parts.push(`${timeLeft.minutes}${t('m')}`)
    }
    parts.push(`${timeLeft.seconds}${t('s')}`)

    return parts.join(' ')
  }

  render() {
    const { showBanner } = this.state
    const { maintenanceInfo, t } = this.props

    if (!showBanner || !maintenanceInfo) {
      return null
    }

    const startDate = moment(maintenanceInfo.startDate).format('DD/MM/YYYY HH:mm')
    const endDate = maintenanceInfo.endDate
      ? moment(maintenanceInfo.endDate).format('DD/MM/YYYY HH:mm')
      : ''

    const description = `${t('Scheduled maintenance from')} ${startDate}${endDate ? ` ${t('to')} ${endDate}` : ''}. ${t('Time remaining')}: ${this.formatTimeLeft()}`

    return (
      <Alert
        message={t('Scheduled Maintenance')}
        description={description}
        type='warning'
        banner
        closable={false}
        style={{ marginBottom: 0 }}
      />
    )
  }
}

const mapStateToProps = (state) => ({
  maintenanceInfo: state.common.maintenanceInfo,
})

export default connect(mapStateToProps)(withTranslation()(MaintenanceBanner))
